export default {
  title: 'Nebula buds AI Вызов', // "Nebula buds AI通话" 翻译为俄语
  userID: 'ID пользователя : ', // "用户ID : "
  hurryUp: 'Ожидание звонка от другой стороны', // "等待对方呼叫"
  waitingCall: 'Ожидание звонка от другой стороны на этой странице, пожалуйста, не закрывайте страницу слишком рано.', // "在此页面等待对方拨打电话，请勿提前关闭。"
  subSwitch: 'Переключатель субтитров', // "字幕开关"
  initWait: 'Ожидание инициализации', // "等待初始化"
  initSuccess: 'Инициализация завершена, ожидайте звонка от другой стороны. Пожалуйста, не закрывайте страницу!', // "初始化完成，等待对方呼叫。请勿关闭页面！"
  callStart: 'Звонок подключен', // "电话接通"
  callEnd: 'Звонок завершен', // "通话结束"
  careful: 'Внимание : ', // "注意 : "
  wait: 'Компонент вызова готов, ожидайте звонка от другой стороны', // "通话组件已准备好,等待对方拨打电话"
  langSwitch: {
    ar: 'Арабский', // "阿拉伯语"
    da: 'Датский', // "丹麦语"
    de: 'Немецкий', // "德语"
    en: 'Английский', // "英语"
    es: 'Испанский', // "西班牙语"
    fil: 'Филиппинский', // "菲律宾语"
    fr: 'Французский', // "法语"
    hi: 'Хинди', // "印地语"
    id: 'Индонезийский', // "印度尼西亚语"
    it: 'Итальянский', // "意大利语"
    ja: 'Японский', // "日文"
    ko: 'Корейский', // "韩语"
    ms: 'Малайский', // "马来语"
    no: 'Норвежский', // "挪威语"
    pt: 'Португальский', // "葡萄牙语"
    ru: 'Русский', // "俄语"
    sv: 'Шведский', // "瑞典语"
    th: 'Тайский', // "泰语"
    tr: 'Турецкий', // "土耳其语"
    vi: 'Вьетнамский', // "越南语"
    zh: 'Китайский' // "中文"
  }
}
